// Cold-storage rental card (Coldroom → "Cold-storage rental accruing"), U18 D1.
//
// The view `cold_storage_revenue` lists every pallet with dispatched_at IS NULL,
// so a pallet that has LEFT the room (loading bay, inspected, rejected) but is
// not yet dispatched still keeps its coldroom_id and still accrues. The card
// used to add them into one figure labelled as if all were in the room. This
// splits the SAME total in two so nothing owed is hidden:
//   inRoom — pallets whose status is IN_COLDROOM
//   left   — the rest, accrued and not yet billed
// inRoom + left always equals the old single figure.

export interface RevenueRow { pallet_id: string; revenue: number | string; rate_per_day?: number | string }
export interface RoomPalletRow { pallet_id: string; status: string | null }

export interface RentalSplit {
  pallets: number
  revenue: number
  inRoomPallets: number
  inRoomRevenue: number
  leftPallets: number
  leftRevenue: number
  rate: number
}

export function splitRentalByStatus(revRows: RevenueRow[], palletRows: RoomPalletRow[]): RentalSplit {
  const statusOf = new Map(palletRows.map(p => [p.pallet_id, p.status]))
  const out: RentalSplit = {
    pallets: 0, revenue: 0, inRoomPallets: 0, inRoomRevenue: 0, leftPallets: 0, leftRevenue: 0, rate: 0,
  }
  for (const r of revRows) {
    if (!statusOf.has(r.pallet_id)) continue
    const rev = Number(r.revenue)
    if (!out.rate && r.rate_per_day != null) out.rate = Number(r.rate_per_day)
    out.pallets += 1
    out.revenue += rev
    if (statusOf.get(r.pallet_id) === 'IN_COLDROOM') { out.inRoomPallets += 1; out.inRoomRevenue += rev }
    else { out.leftPallets += 1; out.leftRevenue += rev }
  }
  return out
}
